import $ from 'jquery';
const DEFAULT_ACTIVE_CLASS = 'favorite-button--active';

const rcProps = window.rcProps || {};
const hearts = rcProps.hearts || {};
// rcProps may be absent; fall back to the limit the server enforces rather than silently passing
const maxFavoritesCount = typeof hearts.maxCount === 'number' ? hearts.maxCount : 1999;
const maxFavoritesCountGuest = typeof hearts.maxCountGuest === 'number' ? hearts.maxCountGuest : 49;
const mensHeart = hearts.mensHeart === 'true';
window.productHearts = {};
const productHearts = window.productHearts;

function initHeart($element){

  $.each($element, function(i, e){
        var events = $._data(e, 'events');

        if (events && events.click)
            return;

        if (!$(e).hasClass(DEFAULT_ACTIVE_CLASS)) {
            $(e).attr('aria-pressed', 'false');
        } else {
            $(e).attr('aria-pressed', 'true');
        }

        $(e).click(function (e) {
            e.preventDefault();
            var element = $(this);
            var productCode = element.data('code');
            heartProductUpdated(element, productCode, function () {

                if (typeof itemUnHearted == "function") {
                    itemUnHearted(element, productCode);
                }
            });
        });
    })
}

function updateHeartCount(count, totalFavoriteCount){
    let $favoriteCount = $("#heart_total_count");
    if ($favoriteCount.length) {
        $favoriteCount.data('count', count);
        // keep the limit-check count fresh; it is otherwise only set on page load
        if (typeof totalFavoriteCount !== 'undefined') {
            $favoriteCount.data('totalFavoriteCount', totalFavoriteCount);
        }
        let favoritesTotal = count > 99 ? "99+" : count;
        $favoriteCount.empty().text(favoritesTotal);

        if (parseInt(favoritesTotal) <= 0) {
            $('.fav-count--ab').hide();
            $("#js-recent-favorites").empty();
            $("#js-recent-favorites").removeClass('js-dropdown__menu popover__content dropdown__menu recent-favorites');
        } else {
            $('.fav-count--ab').show();
            $("#js-recent-favorites").addClass('js-dropdown__menu popover__content dropdown__menu recent-favorites');
            if (typeof loadRecentFavourites == "function") {
                loadRecentFavourites();
            }
        }

    }
}

function heartProductUpdated(element, productCode, callback){
    var container = $(element);
      const $favoriteNotify = element.next('.js-favorite-notify');
      const unfavoritedMessageNotif = element.data('unfavorite-notification');
      const favoritedMessageNotif = element.data('favorite-notification');
      const unfavoriteMessage = element.data('unfavorite-message');
      const favoriteMessage = element.data('favorite-message');
      const messageContainer = '.u-screen-reader';

    const properActiveClass = window.rcProps && window.rcProps.favoriteActiveClass || DEFAULT_ACTIVE_CLASS;

    if (container.hasClass(properActiveClass)) {
        submitHeart('product', productCode, 'remove', undefined, undefined, undefined, undefined, function() {
            container.removeClass(properActiveClass);
            container.attr('aria-pressed', 'false');
            $favoriteNotify.text(unfavoritedMessageNotif);
            container.find(messageContainer).text(favoriteMessage);
        }, callback );
        productHearts[productCode] = false;
    } else {
        const isGuest = rcProps.isGuest;
        const isGuestHeartingEnabled = hearts.enabledForGuest;
        const guestMaxFavoriteCount = maxFavoritesCountGuest;
        var productSize = 0;
        const favItemCount = Number($('#heart_total_count').data('totalFavoriteCount'));
        if(!Number.isNaN(favItemCount)){
            productSize = favItemCount;
        }
        if (isGuest && !(isGuestHeartingEnabled && productSize <= guestMaxFavoriteCount)) {
            showFavLimitPopupModal(hearts.favMaxPopupHref, isGuest, productCode);
            return;
        } else if (!isGuest && productSize > maxFavoritesCount) {
            showFavLimitPopupModal(hearts.favMaxPopupHref, isGuest);
            return;
        }

        submitHeart('product', productCode, 'add', undefined, undefined, undefined, undefined, function() {
            container.addClass(properActiveClass);
            container.attr('aria-pressed', 'true');
            $favoriteNotify.text(favoritedMessageNotif);
            container.find(messageContainer).text(unfavoriteMessage);
        });
        productHearts[productCode] = true;
    }
}

function submitHeart(paramtype, paramvalue){
    if(typeof paramtype ==="undefined" || typeof paramvalue ==="undefined" ) return;
    if(typeof arguments[2] ==="undefined" ) return;
    var psize = "";
    // optional argument
    if(typeof arguments[3] !=="undefined" ) {
        psize = arguments[3];
    }
    var sectionUrl = "";
    if(typeof arguments[4] !=="undefined" ) {
        sectionUrl = arguments[4];
    }
    var callback = null;
    if (typeof arguments[6] !== 'undefined'){
        callback = arguments[6];
    }
    var onSuccess = arguments[7];

    const itemUnHearted = arguments[8];

    var dataToSend="";
    var department = $('#header-jsp').data('department');
    if(paramtype === "product")	{
        dataToSend += "&pcode="+encodeURIComponent(paramvalue);
    }else if(paramtype === "brand")	{
        dataToSend += "&bcode="+encodeURIComponent(paramvalue);
    }
    dataToSend += "&action_T="+encodeURIComponent(arguments[2]);
    if(mensHeart)dataToSend += "&mensBrand="+encodeURIComponent("true");
    else dataToSend += "&mensBrand="+encodeURIComponent("false");
    if(psize !=="")
        dataToSend += "&psize="+encodeURIComponent(psize);
    if(sectionUrl !=="")	dataToSend += "&sectionURL="+encodeURIComponent(sectionUrl);
    if (department)
        dataToSend += "&d="+encodeURIComponent(department);
    let selectedSize = $('#sizeValue').val();
    if (selectedSize) {
        dataToSend += "&psize="+encodeURIComponent(selectedSize);
    }
    var action_T = arguments[2];
    $.ajax({
        type: 'POST',
        url: '/r/ajaxHeartProduct.jsp',
        data: dataToSend,
        success: function(response){
            /*
             // alert("jsp response="+res);
             res = res.replace(/^\s+|\s+$/g,"");
             // alert("jsp response="+res);
             */
            if(paramtype === "product") {
                if (response.exceedsLimit) {
                    showFavLimitPopupModal(hearts.favMaxPopupHref, window.rcProps.isGuest, paramvalue);
                } else if (response.success) {
                    updateHeartCount(response.count, response.totalFavoriteCount);
                    if (typeof itemUnHearted === 'function') {
                        itemUnHearted();
                    }
                }
                if (response.action === 'add') {
                    if(typeof insertCordialUpdateHeartItem === 'function'){
                        insertCordialUpdateHeartItem('add', paramvalue);
                    }
                    if(typeof iPinYouHeartItem === 'function'){
                        iPinYouHeartItem(paramvalue);
                    }
                    if(typeof insertRTBHouseHeartItem === 'function') {
                        insertRTBHouseHeartItem(paramvalue);
                    }
                } else if (response.action === 'remove') {
                    if(typeof insertCordialUpdateHeartItem === 'function'){
                        insertCordialUpdateHeartItem('remove', paramvalue);
                    }
                }
                if(typeof taboolaWishListAction === 'function'){
                    taboolaWishListAction(response.action,paramvalue);
                }
                if(typeof cfyWishListAction === 'function'){
                    cfyWishListAction(response.action, response.code, response.price);
                }

                if(typeof brazeAddToFavorites === 'function') {
                    brazeAddToFavorites(response.action,
                        response.code,
                        response.name,
                        response.size,
                        response.imageUrl,
                        response.productUrl,
                        response.price,
                        response.currency,
                        response.department,
                        response.color,
                        response.brandName,
                        response.category,
                        response.cat1
                    );
                }

            } else if(paramtype === "brand"){
                if(typeof brazeBrandFavorites === 'function') {
                    brazeBrandFavorites(response.action, response.brandName, response.brandId);
                }
            }
            if (typeof callback === 'function'){
                callback();
            }
            if(response.success) {
                if(typeof onSuccess === 'function') {
                    onSuccess();
                }
            }
        }
    });
}


export default {
    initHeart : initHeart,
    updateHeartCount : updateHeartCount
};




// WEBPACK FOOTER //
// ./src/scripts/modules/heart-product.js